import { ORDERS, PRIORITIES, SORTS, WORK_ITEM_TYPES } from '@tasks/contracts/work-items';
import { STATE_CATEGORIES } from '@tasks/contracts/projects';
import { z } from 'zod';
import { csvList } from '#lib/search-params/csv-list';
import { GROUP_KEYS } from './components/group-rows.js';

const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);

/**
 * Lo que viaja en la URL. Todo opcional a propósito: sin defaults en el schema, el router no
 * los escribe y `/VIT` no se convierte en `/VIT?sort=updated&order=desc` al primer clic
 * (diseño §11). Los defaults se aplican al construir la petición, en `to-api-filter`.
 *
 * Estados, etiquetas y personas van por nombre legible, no por UUID: la URL se comparte.
 */
export const workItemSearchSchema = z.object({
  type: csvList(z.enum(WORK_ITEM_TYPES)),
  state: csvList(z.string()),
  stateCategory: csvList(z.enum(STATE_CATEGORIES)),
  assignee: csvList(z.string()),
  label: csvList(z.string()),
  priority: csvList(z.enum(PRIORITIES)),
  parent: z.string().optional(),
  q: z.string().max(200).optional(),
  dueBefore: isoDate.optional(),
  dueAfter: isoDate.optional(),
  /**
   * Acepta el texto de la URL y el booleano que manda un `navigate` en código: el router tipa
   * la navegación con la *entrada* del schema, así que admitir solo texto rompería la casilla.
   */
  includeDone: z.union([z.boolean(), z.stringbool()]).optional(),
  sort: z.enum(SORTS).optional(),
  order: z.enum(ORDERS).optional(),
  /** Cómo se reparte la lista en bandas. No es un filtro: no quita ni añade tareas. */
  group: z.enum(GROUP_KEYS).optional(),
  /** Panel de detalle. Es un parámetro, no una ruta: se abre sin perder filtros ni selección. */
  item: z.string().optional(),
});

export type WorkItemSearch = z.infer<typeof workItemSearchSchema>;
